<template>
  <div class="app-container">
<el-row :gutter="20" class="elrow">
  <el-col :span="8">
<div ref="leftchart" style=" width: 500px; height:250px;"></div>
   
  </el-col>
  <el-col :span="16">
       <el-card  ref="myCard2" class="box-card" :body-style="{height: cardh+'px',overflowY:'auto'}" >
  <div slot="header" class="clearfix">
    <div class="flex-row justify-between">
    <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">&nbsp;&nbsp;</div>
    <span style="padding-left: 6px; position: absolute;font-weight: 650;">评分自测情况</span>
    <!-- <span style="padding-left: 120px;position: absolute;font-weight: 300;font-size: 14px;height: 30px;">解析完后可手动修改</span> -->
    <!-- <svg t="1757669489386" @click="toggleFullScreen( 'myCard2') "   style="float: right; padding: 3px 0;width: 20px; height: 20px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200" height="200"><path d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z" fill="#333333" p-id="2421"></path></svg> -->
    </div>
  </div>


    <el-table v-loading="loading" :data="businessqualificationList" @selection-change="handleSelectionChange" style="height: 250px;"   max-height="650">
      <!-- <el-table-column type="selection" width="40" align="center" /> -->
 
      <el-table-column label="评分项" align="center" prop="qualificationNo" />
  
      <el-table-column label="具体内容" align="center" prop="effectBegin" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.effectBegin, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分值" align="center" prop="certificateType" />
    
      <el-table-column label="自测分值" align="center" prop="version" />
      <el-table-column label="结论" align="center" prop="version" />
     
    </el-table>


</el-card>
</el-col>


</el-row>

<el-row :gutter="20" class="elrow">
  <el-col :span="8">
    <span>投标文件</span>
  <el-tree
            :data="tree"
            highlight-current
            node-key="id"
            :props="{
                children: 'children',
                label: 'name'
            }"
            @node-expand="openTreeNode"
            @node-collapse="closeTreeNode"
            ref="tree"
            @node-contextmenu="openTreeMenu"
            default-expand-all	
        >
        <template #default="{ node, data }">
      <span class="custom-node">
        <!-- 一级节点图标 -->
        <i v-if="node.level === 1" class="el-icon-folder-opened" v-html="'&nbsp;&nbsp;'"> </i>
        <!-- 二级节点图标 -->
        <i v-else-if="node.level === 2" class="el-icon-document" v-html="'&nbsp;&nbsp;'"></i>
        <!-- 三级节点图标 -->
        <i v-else-if="node.level === 3" class="el-icon-set-up" v-html="'&nbsp;&nbsp;'"></i>
        <!-- 其他节点图标 -->
        <i v-else class="el-icon-collection" v-html="'&nbsp;&nbsp;'"></i>
        <span>{{ node.label }}</span>
      </span>
    </template>
        </el-tree>
   
  </el-col>
  <el-col :span="16">
  
<div>

<div id="text-dom-il4xjiksUv3QTZS8Gt2xiH" class="text">
  <p class="listRTL listLTR" style="margin-bottom: 3.9px;">
    <span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">针对AI应用系统的服务器配置、部署和数据备份需求进行系统性规划，确保系统稳定运行和数据安全，具体包括：</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">1.服务器选型与配置方案：</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(189,49,36,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 700;line-height: 17px;">(1)硬件配置规划：CPU性能配置、内存容量规划、存储空间配置、网络带宽需求、服务器扩展能力；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(189,49,36,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 700;line-height: 17px;">(2)操作系统选型：系统版本选择、安全补丁策略、系统优化配置、系统监控方案；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(189,49,36,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 700;line-height: 17px;">(3)数据库配置：数据库类型选择、数据库参数优化、数据库性能调优、连接池配置；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(189,49,36,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 700;line-height: 17px;">(4)中间件配置：应用服务器选型、缓存服务配置、消息队列配置、负载均衡设置；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">2.系统部署方案：</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(1)部署架构设计：应用服务器集群方案、数据库集群方案、负载均衡架构、容灾备份架构；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(2)网络环境配置：网络拓扑设计、安全域划分、防火墙策略、访问控制策略；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(3)应用系统部署：智能报告模块部署、知识库模块部署、智能问数模块部署、系统集成配置；</span></p><p><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(4)系统监控部署：性能监控配置、告警阈值设置、日志收集方案、监控可视化配置；</span></p></div>

</div>

</el-col>


</el-row>
  </div>
</template>

<script>

import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import { listSelfassessment, getSelfassessment, delSelfassessment, addSelfassessment, updateSelfassessment } from "@/api/intelligentinspection/selfassessment";

export default {
  name: "Selfassessment",
      props: {
    tree: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
        chart: null,
                           // three
 showTreeMenu: false,
            contextNode: {},
        
       
      // end three
    };
  },
  created() {
    // this.getList();
  },
     mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
        
    initChart() {
      this.chart = echarts.init(this.$refs.leftchart)
var option = {
    // title: {
    //     text: 'AAAA',
    // },
    tooltip: {},
    // legend: {
    //     symbol: 'circle',
    //     right: 'right',
    // },
    radar: {
        indicator: [
            { name: '商务', max: 100 },
            { name: '技术', max: 100 },
            { name: '价格', max: 100 },
        ],
        // splitArea: {
        //     areaStyle: {
        //         color: ['rgba(37,79,146,.2)', 'rgba(37,79,146,.2)', 'rgba(37,79,146,.2)', 'rgba(37,79,146,.2)'],
        //         shadowColor: 'rgba(0, 0, 0, 0.2)',
        //         shadowBlur: 10,
        //     },
        // },
        // axisLine: {
        //     lineStyle: {
        //         color: 'rgba(211, 253, 250, 0.8)',
        //     },
        // },
        // splitLine: {
        //     lineStyle: {
        //         color: 'rgba(211, 253, 250, 0.8)',
        //     },
        // },
    },
    series: [
        {
            type: 'radar',
            data: [
                { name: '1', value: [22, 82, 41], areaStyle: {} },
                { name: '2', value: [42, 38, 96], areaStyle: {} },
             
            ],
        },
    ],
};

      this.chart.setOption(option)
    }
  }
};
</script>
